import { render, staticRenderFns } from "./PluginEditorWindow.vue?vue&type=template&id=b88a3cbe&scoped=true&"
import script from "./PluginEditorWindow.vue?vue&type=script&lang=js&"
export * from "./PluginEditorWindow.vue?vue&type=script&lang=js&"
import style0 from "./PluginEditorWindow.vue?vue&type=style&index=0&id=b88a3cbe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88a3cbe",
  null
  
)

export default component.exports